module.exports = __webpack_public_path__ + "static/img/2.63e4595.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/juhua/R404A/2.jpg
// module id = i8zb
// module chunks = 1